import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowUpRight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_6502_196939)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M12.0031 7.0605L5.5478 13.5157L4.4873 12.4553L10.9418 6H5.25306V4.5H13.5031V12.75H12.0031V7.0605Z",
			fill: "#4B1DF4"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_6502_196939",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 18,
			height: 18,
			fill: "white"
		})
	}) })]
});
export default SvgArrowUpRight;
